import $axios from '@/axios-instance.js'

export const financeIntegrationService = {
  testConnection,
  getCustomer,
  getCustomers,
  setFortnoxActivationCode,
  matchCustomers,
  createFortnoxCustomers,
  removeInvalidLinks
}

function removeInvalidLinks (payload) {
  return $axios.post(`${process.env.ROOT_API}/finance-integration/remove-invalid-links`, payload).then(response => {
    return response.data
  })
}

function createFortnoxCustomers (customers) {
  return $axios.post(`${process.env.ROOT_API}/finance-integration/create-fortnox-customers`, customers).then(response => {
    return response.data
  })
}

function testConnection () {
  return $axios.get(`${process.env.ROOT_API}/finance-integration/test-connection`).then(response => {
    return response.data
  })
}

function setFortnoxActivationCode (code) {
  return $axios.get(`${process.env.ROOT_API}/finance-integration/set-fortnox-activation-code/${code}`).then(response => {
    return response.data
  })
}

function getCustomer (fortnoxCustomerId) {
  return $axios.get(`${process.env.ROOT_API}/finance-integration/get-customers/${fortnoxCustomerId}`).then(response => {
    return response.data
  })
}

function matchCustomers () {
  return $axios.get(`${process.env.ROOT_API}/finance-integration/match-customers`).then(response => {
    return response.data
  })
}

function getCustomers () {
  return $axios.get(`${process.env.ROOT_API}/finance-integration/get-customers`).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/finance-integration.service.js